"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import Knowledge from "../../../components/Admin/Knowledge/KnowledgeOriginal";
var backarrow_1 = __importDefault(require("./backarrow"));
var cancel_1 = __importDefault(require("./cancel"));
var delete_1 = __importDefault(require("./delete"));
var download_1 = __importDefault(require("./download"));
var edit_1 = __importDefault(require("./edit"));
var education_1 = __importDefault(require("./education"));
var education_report_1 = __importDefault(require("./education-report"));
var expand_1 = __importDefault(require("./expand"));
var eyeclose_1 = __importDefault(require("./eyeclose"));
var eyeopen_1 = __importDefault(require("./eyeopen"));
var healthcoach_1 = __importDefault(require("./healthcoach"));
var healthcoachlogo_1 = __importDefault(require("./healthcoachlogo"));
var key_1 = __importDefault(require("./key"));
var language_1 = __importDefault(require("./language"));
var logo_1 = __importDefault(require("./logo"));
var logoff_1 = __importDefault(require("./logoff"));
var myfinance_1 = __importDefault(require("./myfinance"));
var myfinance_report_1 = __importDefault(require("./myfinance-report"));
var nuttitionIcon_1 = __importDefault(require("./nuttitionIcon"));
var organization_1 = __importDefault(require("./organization"));
var plus_1 = __importDefault(require("./plus"));
var remove_1 = __importDefault(require("./remove"));
var report_1 = __importDefault(require("./report"));
var save_1 = __importDefault(require("./save"));
var service_1 = __importDefault(require("./service"));
var setting_1 = __importDefault(require("./setting"));
var tick_1 = __importDefault(require("./tick"));
var tool_1 = __importDefault(require("./tool"));
var usage_1 = __importDefault(require("./usage"));
var user_1 = __importDefault(require("./user"));
var widget_1 = __importDefault(require("./widget"));
var zip_1 = __importDefault(require("./zip"));
var knowledge_1 = __importDefault(require("./knowledge"));
var monitoring_1 = __importDefault(require("./monitoring"));
var country_1 = __importDefault(require("./country"));
var fosa_1 = __importDefault(require("./fosa"));
var hclogo_white_1 = __importDefault(require("./hclogo-white"));
var Icon = [
    {
        name: "hclogowhite",
        icon: hclogo_white_1.default,
    },
    {
        name: "education_report",
        icon: education_report_1.default,
    },
    {
        name: "knowledge",
        icon: knowledge_1.default,
    },
    {
        name: "my_finance_report",
        icon: myfinance_report_1.default,
    },
    {
        name: "my_finance_report",
        icon: myfinance_report_1.default,
    },
    {
        name: "report",
        icon: report_1.default,
    },
    {
        name: "setting",
        icon: setting_1.default,
    },
    {
        name: "tool",
        icon: tool_1.default,
    },
    {
        name: "remove",
        icon: remove_1.default,
    },
    {
        name: "delete",
        icon: delete_1.default,
    },
    {
        name: "language",
        icon: language_1.default,
    },
    {
        name: "user",
        icon: user_1.default,
    },
    {
        name: "key",
        icon: key_1.default,
    },
    {
        name: "eyeClose",
        icon: eyeclose_1.default,
    },
    {
        name: "eyeOpen",
        icon: eyeopen_1.default,
    },
    {
        name: "backArrow",
        icon: backarrow_1.default,
    },
    {
        name: "logo",
        icon: logo_1.default,
    },
    {
        name: "logOut",
        icon: logoff_1.default,
    },
    {
        name: "healthcoachlogo",
        icon: healthcoachlogo_1.default,
    },
    {
        name: "healthcoachIcon",
        icon: healthcoach_1.default,
    },
    {
        name: "",
        icon: healthcoach_1.default,
    },
    {
        name: "widgetIcon",
        icon: widget_1.default,
    },
    {
        name: "education",
        icon: education_1.default,
    },
    {
        name: "myFinance",
        icon: myfinance_1.default,
    },
    {
        name: "service",
        icon: service_1.default,
    },
    {
        name: "usage",
        icon: usage_1.default,
    },
    {
        name: "save",
        icon: save_1.default,
    },
    {
        name: "plus",
        icon: plus_1.default,
    },
    {
        name: "tick",
        icon: tick_1.default,
    },
    {
        name: "cancel",
        icon: cancel_1.default,
    },
    {
        name: "edit",
        icon: edit_1.default,
    },
    {
        name: "NutriCoach",
        icon: nuttitionIcon_1.default,
    },
    {
        name: "expand",
        icon: expand_1.default,
    },
    {
        name: "zip",
        icon: zip_1.default,
    },
    {
        name: "download",
        icon: download_1.default,
    },
    {
        name: "organization",
        icon: organization_1.default,
    },
    { name: "monitoring", icon: monitoring_1.default },
    {
        name: "country",
        icon: country_1.default,
    },
    {
        name: "fosa",
        icon: fosa_1.default,
    },
];
exports.default = Icon;
